import { IconX } from '@vtex/shoreline'

import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import styles from './styles.module.css'

export type BulkBarAction = {
  id: string
  label: string
  icon?: React.ReactNode
  critical?: boolean
  disabled?: boolean
  onClick: () => void
}

/** Barra de ações em massa fixa no rodapé; some quando a seleção é limpa. */
export const BulkBar: React.FC<{
  count: number
  label: string
  actions: BulkBarAction[]
  onClear: () => void
}> = ({ count, label, actions, onClear }) => {
  const { t } = useAPPTranslation()

  if (!count) return null

  return (
    <section
      className={styles.bulkBar}
      aria-label={t('rm:advertiserCatalog.bulk.region')}
    >
      <div className={styles.bulkBarInner}>
        <span className={styles.bulkCount}>{label}</span>

        {actions.map(action => (
          <span key={action.id} className="d-inline-flex align-items-center">
            <span className={styles.bulkDivider} aria-hidden="true" />
            <button
              type="button"
              disabled={action.disabled}
              className={`${styles.bulkAction} ${
                action.critical ? styles.bulkActionCritical : ''
              }`}
              onClick={action.onClick}
            >
              {action.icon}
              {action.label}
            </button>
          </span>
        ))}

        <span className={styles.bulkDivider} aria-hidden="true" />
        <button
          type="button"
          className={styles.bulkClear}
          onClick={onClear}
          aria-label={t('rm:advertiserCatalog.bulk.clear')}
        >
          <IconX />
        </button>
      </div>
    </section>
  )
}
